import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';
import { Button, HStack, Modal, theme } from '@sg/garnish';

export const AddressFormFooter = (props: AddressFormFooterProps) => {
  const {
    canSubmit,
    isLoading,
    onSubmit,
    canDelete,
    isDeleting,
    onDelete,
    submitCtaOverride,
  } = props;

  const { formatMessage } = useIntl();

  return (
    <Modal.Footer style={styles.footer} withoutTopBorder>
      <HStack itemsPerRow={canDelete ? 2 : 1} gap={theme.spacing['4']}>
        {canDelete ? (
          <Button
            size="large"
            palette="caution"
            isLoading={isDeleting}
            onPress={onDelete}
            accessibilityLabel={formatMessage(messages.removeAddressA11yLabel)}
            accessibilityHint={formatMessage(messages.removeAddressA11yLabel)}
            accessibilityRole="button"
          >
            <FormattedMessage {...messages.removeAddressLabel} />
          </Button>
        ) : null}

        <Button
          size="large"
          isLoading={isLoading}
          onPress={onSubmit}
          disabled={!canSubmit}
          accessibilityLabel={formatMessage(messages.saveAddressA11yLabel)}
          accessibilityHint={formatMessage(messages.saveAddressA11yLabel)}
          accessibilityRole="button"
        >
          {submitCtaOverride ? (
            submitCtaOverride
          ) : (
            <FormattedMessage {...messages.saveAddressLabel} />
          )}
        </Button>
      </HStack>
    </Modal.Footer>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────────

const messages = defineMessages({
  saveAddressLabel: {
    defaultMessage: 'Save',
    description: 'Address Form | Footer | Save',
  },
  saveAddressA11yLabel: {
    defaultMessage: 'Submit address form',
    description: 'Address Form | Footer | Save address a11y label',
  },
  removeAddressLabel: {
    defaultMessage: 'Remove',
    description: 'Address Form | Footer | Remove',
  },
  removeAddressA11yLabel: {
    defaultMessage: 'Remove address',
    description: 'Address Form | Footer | Remove address a11y label',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type AddressFormFooterProps = Readonly<{
  canSubmit?: boolean;
  isLoading?: boolean;
  onSubmit: () => void;
  canDelete?: boolean;
  isDeleting?: boolean;
  onDelete?: () => void;
  submitCtaOverride?: string;
}>;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  footer: {
    flexDirection: 'row',
    padding: theme.spacing['6'],
    paddingTop: theme.spacing['6'],
  },
});
